import { render, staticRenderFns } from "./new.videos.page.vue?vue&type=template&id=78fc3534&"
import script from "./new.videos.page.vue?vue&type=script&lang=js&"
export * from "./new.videos.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports